import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Box,
    CircularProgress,
    Skeleton,
    Tooltip,
    Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DeleteBtn, SearchBtn } from '../../Buttons/Buttons';
import * as HeaderAuthentication from '../../../components/HeaderAuthentication'
import { downloadViewedContactsDatas, getupdateViewedContactsData, postDeleteViewedContactsData } from '../../redux/action';
import { useDispatch } from 'react-redux';
import { Circles } from 'react-loader-spinner';
import noDataGif from '../../../assets/images/No data.gif'
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { insertBulkPhones, loadEnrichData, loadGetPhone, unlockBulkPhone, webHookGetPhone } from '../../redux/ai_connect/ai_action';
import { toast } from 'react-toastify';
import { aiBaseUrl } from '../../BaseURL';
import { emailAccessFail, emailAccessSuccess } from '../../CommonFile/SVGIcons';
import { useLocation } from "react-router-dom";
import Select from "react-select";
dayjs.extend(relativeTime);

export default function ViewedContactsTable({
    page,
    setPage,
    rowsPerPage,
    totalDataCount,
    loading,
    fetchViewedContact,
    loadingMore,
    setLoadingMore,
    tableHeight,
    selectedRowsData,
    setSelectedRowsData,
    getViewedContacts,
    div2Ref,
    // handleDownload,
    setDownloading,
    signInID,
    sbnID,
    role,
    listName,
    listProvider,
    setBulkUnlock,
    setSelectFilter,
    selectFilter
}) {

    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const { getCredits } = useSelector(state => state.data);

    const [selectedRowIds, setSelectedRowIds] = React.useState({
        type: 'include',
        ids: new Set(),
    });
    const [resetKey, setResetKey] = React.useState(0);

    const [loadingRows, setLoadingRows] = React.useState({});
    const [loadingPhoneRows, setLoadingPhoneRows] = React.useState({});
    const [isSelectAll, setIsSelectAll] = React.useState(false);

    const resolveProvider = (row) => {
        const p =
            row?.provider ||
            listProvider ||
            sessionStorage.getItem("list_provider") ||
            sessionStorage.getItem("last_provider_used")
        const resolved = String(p).toLowerCase();
        console.log("RESOLVE PROVIDER =>", {
            rowProvider: row?.provider,
            listProvider,
            sessionList: sessionStorage.getItem("list_provider"),
            lastUsed: sessionStorage.getItem("last_provider_used"),
            resolved,
        });
        return resolved;
    };

    const filterDropdowns = [
        { label: "All Contacts", value: "All" },
        { label: "Locked Contacts", value: "Locked" },
        { label: "Enriched Contacts", value: "Enriched" }
    ]

    // region unlock phone number
    const handlePhoneUnlock = async (uiRowId, email_status) => {
        const result = await Swal.fire({
            title: 'Unlock Phone?',
            html: `
        <div style="text-align: center; line-height: 1.6;">
            <p style="font-size: 16px; color: #555; margin-bottom: 20px;">
                ${email_status === 0 ? "9" : "9"} credit will be used to unlock this phone.
            </p>

            <div style="
                background: #f8fafc;
                border: 1px solid #e2e8f0;
                border-radius: 12px;
                padding: 16px;
                margin-bottom: 20px;
            ">
                <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                    <span>📞 Phone Credits</span>
                    <strong>${email_status === false ? "9" : "9"} Credits</strong>
                </div>

                <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                    <span>✉️ Email Credits</span>
                    <strong>Free</strong>
                </div>
            </div>

            <p style="font-size: 14px; color: #64748b;">
                Proceeding will deduct these credits from your account.
            </p>
        </div>
    `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Unlock",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#2563eb",
            cancelButtonColor: "#dc2626",
            reverseButtons: true,
            focusCancel: true,
            width: "500px",
            customClass: {
                popup: "rounded-xl",
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn",
            }
        });
        console.log(result, "result")
        if (!result.isConfirmed) return;

        try {
            if (getCredits.credits_aval < 9) {
                toast.warning(`You dont have enough credits to unlock the phone. Please upgrade the plan`);
                return;
            }

            setLoadingPhoneRows((prev) => ({
                ...prev, [uiRowId]: true
            }))
            // const source_id = getViewedContacts.find(
            //     item => item.id === uiRowId
            // )?.source_id;
            // const post_view = {
            //     person_id: source_id
            // }; 
            const row = getViewedContacts.find((item) => item.id === uiRowId);
            const source_id = row?.source_id;
            const post_view = {
                person_id: source_id,
                provider: resolveProvider(row),   // ★ ADD
                list_name: listName,
                user_id: parseInt(signInDetails[0]?.id),
                user_name: signInDetails[0]?.name,
                sbn_id: signInDetails[0]?.sbn_id,
            };
            console.log("PHONE UNLOCK PAYLOAD =>", post_view);
            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(post_view),
            };

            const resp = await dispatch(loadGetPhone(requestOption));
            if (resp[0]?.first_name === null && resp[0]?.email === null && resp[0]?.phone === null && resp[0]?.last_name === null) {
                const updatedData = getViewedContacts.map((item) => {
                    if (item.source_id === resp[0].id) {
                        return {
                            ...item,
                            firstname: resp[0].full_person?.first_name,
                            lastname: resp[0].full_person?.last_name,
                            email: resp[0].email,
                            state: resp[0].state,
                            city: resp[0].city,
                            country: resp[0].country,
                            zipcode: resp[0].full_person?.postal_code,
                            industry: resp[0].full_person?.organization?.industries?.join(','),
                            sub_industry: resp[0].full_person?.organization?.secondary_industries?.join(','),
                            technology: resp[0].full_person?.organization?.technology_names?.join(','),
                            job_level: resp[0].full_person?.seniority,
                            job_department: resp[0].full_person?.departments?.join(','),
                            address: resp[0].full_person?.address,
                            website: resp[0].website_url,
                            email_status: "true",
                            phone_status: "true",
                            enrich_status: 1
                        };
                    }
                    return item;
                });
                dispatch(getupdateViewedContactsData(updatedData));
                setSelectedRowIds({
                    type: 'include',
                    ids: new Set(),
                })
                setSelectedRowsData([])
                setLoadingPhoneRows((prev) => ({
                    ...prev,
                    [uiRowId]: false,
                }));

                return;
            }

            startSingleProgressTracking(resp, uiRowId);

            // setTimeout(async () => {


            // }, 5000);
        } catch (err) {
            if (err.name === "AbortError") {
                console.log("Previous request aborted ✅");
            } else {
                console.log(err);
            }
        } finally {
            console.log("finished");
        }
    };

    const startSingleProgressTracking = (resp, uiRowId) => {
        const interval = setInterval(async () => {
            const completed = await getUnlockedPhones(
                resp, uiRowId,
                interval
            );

            if (completed) {
                clearInterval(interval);
            }
        }, 10000);
    };

    let interval_count_single = 0
    const getUnlockedPhones = async (resp, uiRowId, interval) => {
        const response = await fetch(
            `${aiBaseUrl}ai/check-webhook-status`
        );
        const data = await response.json();
        interval_count_single = interval_count_single + 1

        if (data.total !== 0) {
            clearInterval(interval);
            const personId = getViewedContacts.find(
                item => item.id === uiRowId
            )?.source_id;
            const insertData = {
                person_id: personId,
                user_id: parseInt(signInDetails[0].id),
                user_name: signInDetails[0].name,
                sbn_id: signInDetails[0].sbn_id,
                list_name: listName,
            };

            const requestOption = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(insertData),
            };

            dispatch(webHookGetPhone(requestOption))
                .then((response) => {
                    if (response.success === true) {
                        const updatedData = getViewedContacts.map((item) => {
                            if (item.source_id === resp[0].id) {
                                return {
                                    ...item,
                                    firstname: resp[0].full_person?.first_name,
                                    lastname: resp[0].full_person?.last_name,
                                    email: resp[0].email,
                                    phone: response?.mobile,
                                    state: resp[0].state,
                                    city: resp[0].city,
                                    country: resp[0].country,
                                    zipcode: resp[0].full_person?.postal_code,
                                    industry: resp[0].full_person?.organization?.industries?.join(','),
                                    sub_industry: resp[0].full_person?.organization?.secondary_industries?.join(','),
                                    technology: resp[0].full_person?.organization?.technology_names?.join(','),
                                    job_level: resp[0].full_person?.seniority,
                                    job_department: resp[0].full_person?.departments?.join(','),
                                    address: resp[0].full_person?.address,
                                    website: resp[0].website_url,
                                    email_status: "true",
                                    phone_status: "true",
                                    enrich_status: 1
                                };
                            }
                            return item;
                        });
                        dispatch(getupdateViewedContactsData(updatedData));
                        setSelectedRowIds({
                            type: 'include',
                            ids: new Set(),
                        })
                        setSelectedRowsData([])
                        setLoadingPhoneRows((prev) => ({
                            ...prev,
                            [uiRowId]: false,
                        }));
                    } else {
                        const updatedData = getViewedContacts.map((item) => {
                            if (item.source_id === resp[0].id) {
                                return {
                                    ...item,
                                    firstname: resp[0].full_person?.first_name,
                                    lastname: resp[0].full_person?.last_name,
                                    email: resp[0].email,
                                    phone: "NA",
                                    state: resp[0].state,
                                    city: resp[0].city,
                                    country: resp[0].country,
                                    zipcode: resp[0].full_person?.postal_code,
                                    industry: resp[0].full_person?.organization?.industries?.join(','),
                                    sub_industry: resp[0].full_person?.organization?.secondary_industries?.join(','),
                                    technology: resp[0].full_person?.organization?.technology_names?.join(','),
                                    job_level: resp[0].full_person?.seniority,
                                    job_department: resp[0].full_person?.departments?.join(','),
                                    address: resp[0].full_person?.address,
                                    website: resp[0].website_url,
                                    email_status: "true",
                                    phone_status: "true",
                                    enrich_status: 1
                                };
                            }
                            return item;
                        });
                        dispatch(getupdateViewedContactsData(updatedData));
                        setSelectedRowIds({
                            type: 'include',
                            ids: new Set(),
                        })
                        setSelectedRowsData([])
                        setLoadingPhoneRows((prev) => ({
                            ...prev,
                            [uiRowId]: false,
                        }));
                    }
                }
                )
                .catch((err) => {
                    setLoadingPhoneRows((prev) => ({
                        ...prev,
                        [uiRowId]: false,
                    }));
                    if (err.name === "AbortError") {
                        console.log("Previous request aborted ✅");
                    } else {
                        console.log(err);
                    }
                });
        } else if (interval_count_single >= 10) {
            clearInterval(interval);
            setLoadingPhoneRows((prev) => ({
                ...prev,
                [uiRowId]: false,
            }));

        }
    };
    // endregion

    // region unlock email
    const handleEmailUnlock = async (uiRowId, type) => {
        let textVal = "1 credit will be used to unlock this email.";
        if (type === "enrich") {
            textVal = "1 credit will be used to enrich this record."
        }
        const result = await Swal.fire({
            title: 'Unlock Email?',
            html: `
        <div style="text-align: center; line-height: 1.6;">
            <p style="font-size: 16px; color: #555; margin-bottom: 20px;">
                ${textVal}
            </p>

            <p style="font-size: 14px; color: #64748b;">
                Proceeding will deduct these credits from your account.
            </p>
        </div>
    `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Unlock",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#2563eb",
            cancelButtonColor: "#dc2626",
            reverseButtons: true,
            focusCancel: true,
            width: "500px",
            customClass: {
                popup: "rounded-xl",
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn",
            }
        });
        if (!result.isConfirmed) return;

        try {
            if (getCredits.credits_aval <= 0) {
                toast.warning(`You dont have enough credits to unlock the email. Please upgrade the plan`);
                return;
            }
            // Start loader for this row only
            setLoadingRows((prev) => ({
                ...prev,
                [uiRowId]: true,
            }));

            // const personId = getViewedContacts.find(
            //     item => item.id === uiRowId
            // )?.source_id;
            // const post_view = {
            //     person_id: personId
            // }; 

            const row = getViewedContacts.find((item) => item.id === uiRowId);
            const personId = row?.source_id;
            const post_view = {
                person_id: personId,
                provider: resolveProvider(row),   // ★ ADD
                list_name: listName,
                user_id: parseInt(signInDetails[0]?.id),
                user_name: signInDetails[0]?.name,
                sbn_id: signInDetails[0]?.sbn_id,
            }; 
            console.log("EMAIL UNLOCK PAYLOAD =>", post_view);

            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(post_view),
            };

            const resp = await dispatch(loadEnrichData(requestOption));

            const updatedData = getViewedContacts.map((item) => {
                console.log(item.id === resp[0].id, "item.id === resp[0].id")
                if (item.source_id === resp[0].id) {
                    return {
                        ...item,
                        firstname: resp[0].full_person?.first_name,
                        lastname: resp[0].full_person?.last_name,
                        email: resp[0].email,
                        phone: resp[0].phone,
                        state: resp[0].state,
                        city: resp[0].city,
                        country: resp[0].country,
                        zipcode: resp[0].full_person?.postal_code,
                        industry: resp[0].full_person?.organization?.industries?.join(','),
                        sub_industry: resp[0].full_person?.organization?.secondary_industries?.join(','),
                        technology: resp[0].full_person?.organization?.technology_names?.join(','),
                        job_level: resp[0].full_person?.seniority,
                        job_department: resp[0].full_person?.departments?.join(','),
                        address: resp[0].full_person?.address,
                        website: resp[0].website_url,
                        email_status: "true",
                        enrich_status: 1
                    };
                }

                return item;
            });
            dispatch(getupdateViewedContactsData(updatedData));
            setSelectedRowIds({
                type: 'include',
                ids: new Set(),
            })
            setSelectedRowsData([])

        } catch (err) {
            if (err.name === "AbortError") {
                console.log("Previous request aborted ✅");
            } else {
                console.log(err);
            }
        } finally {
            // Stop loader for this row
            setLoadingRows((prev) => ({
                ...prev,
                [uiRowId]: false,
            }));
        }
    };
    // endregion

    // region download contacts
    const handleDownload = async () => {
        let item_to_download = [];
        let unlocked_data = 0;

        if (selectedRowsData.length !== 0) {
            item_to_download = selectedRowsData.filter(
                (item) =>
                    item.phone_status === "true" ||
                    Number(item.enrich_status) === 1
            );

            unlocked_data = selectedRowsData.length - item_to_download.length
        } else {
            item_to_download = getViewedContacts.filter(
                (item) =>
                    (item.phone_status === "true" || Number(item.enrich_status) === 1)
            );

            unlocked_data = getViewedContacts.length - item_to_download.length
        }

        let text = "";
        if (unlocked_data === 0) {
            text = `Only unlocked contacts are available for download. In the selected list all contacts are unlocked or enriched data, Available for download.`
        } else {
            text = `Only unlocked contacts are available for download. There are ${item_to_download.length} contact(s) with unlocked or enriched data. Please unlock the remaining contacts if you wish to download the entire list.`
        }

        const result = await Swal.fire({
            title: 'Download Contacts?',
            html: `
        <div style="text-align: center; line-height: 1.6;">

            <p style="font-size: 14px; color: #555;">
                ${text}
            </p>
            <p style="font-size: 14px; color: #64748b;">
                Do you want to download available contacts.?
            </p>
        </div>
    `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Download",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#2563eb",
            cancelButtonColor: "#dc2626",
            reverseButtons: true,
            focusCancel: true,
            width: "500px",
            customClass: {
                popup: "rounded-xl",
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn",
            }
        });

        if (!result.isConfirmed) return;

        setDownloading(true);

        console.log(item_to_download, "item_to_download");

        if (item_to_download.length === 0) {
            alert("No contacts with enriched data found.");
            setDownloading(false);
            return;
        }

        // const exportData = item_to_download.map((item) => ({
        //     First_Name: item.firstname,
        //     Last_Name: item.lastname,
        //     Company: item.company,
        //     Industry: item.industry,
        //     Job_Title: item.job_title,
        //     Email: item.email,
        //     Phone: item.phone,
        //     City: item.city,
        //     State: item.state,
        //     Country: item.country,
        //     Website: item.website,
        //     Employee_Size: item.employee_size,
        //     Revenue: item.revenue,
        //     Address: item.address,
        //     List_Name: item.list_name
        // }));
        let exportData = []
        if (selectedRowsData.length !== 0) {
            exportData = item_to_download.map((item) => item.apiId);
        } else {
            exportData = item_to_download.map((item) => item.id);
        }

        // const worksheet = XLSX.utils.json_to_sheet(exportData);

        // const workbook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

        // const excelBuffer = XLSX.write(workbook, {
        //     bookType: "xlsx",
        //     type: "array",
        // });

        // const blob = new Blob(
        //     [excelBuffer],
        //     {
        //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        //     }
        // );

        // saveAs(blob, `contacts_${Date.now()}.xlsx`);

        const downloaddata = {
            user_id: parseInt(signInDetails[0]?.id),
            sbn_id: sbnID,
            list_name: listName,
            role: role,
            contact_ids: exportData.join(",")
            // contact_ids: exportData
        }

        console.log(item_to_download, "item_to_download")
        console.log(exportData, "exportData")

        const requestOption = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(downloaddata),
        };

        const resp = await dispatch(downloadViewedContactsDatas(requestOption, setDownloading));

        // console.log(resp)
    }
    // endregion

    const renderSkeletonCell = (params) => {
        if (params.row?.isSkeleton) {
            return <Skeleton variant="text" width="100%" />;
        }

        if (params.field === 'phone') {
            return params?.row?.phone_status !== "true" && (params?.row?.phone === 'NA' || params?.row?.phone === null || params?.row?.phone === "-") ? (
                <span
                    style={{
                        color: '#007bff',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    onClick={(e) => { e.stopPropagation(); handlePhoneUnlock(params.row.apiId, params?.row?.enrich_status) }}
                > {loadingPhoneRows[params.row.apiId] ? (
                    <div>
                        <CircularProgress size={16} />
                    </div>
                ) : (
                    <><div>
                        <Tooltip
                            title={params?.row?.enrich_status === 0 ? `Email and Phone will be enriched. Enrichment can use 9 credit for phone and free for email if available..` :
                                `Phone will be enriched. Enrichment can use 9 credit for phone.`
                            }
                            arrow
                            placement="top"
                        >
                            <span className='unlock-item'><i className="fa fa-phone" style={{ marginRight: 8 }}></i>
                                Unlock Phone</span>
                        </Tooltip>
                    </div></>
                )}

                </span>
            ) : (
                <><div>{(params.value !== "-" && params.value !== "NA") ? <span className='locked_value'><i className="fa fa-phone" style={{ marginRight: 8 }}></i>{params.value}</span> :
                    // <span className='no-value-item'> NA</span>
                    <>
                        <div>
                            <span className="unlocked-no-item">

                                <i className="fa fa-phone" style={{ marginRight: 8 }}></i>


                                No Phone
                            </span>
                        </div>
                    </>
                }</div>
                </>
            );
        }

        if (params.field === "email") {
            return params?.row?.has_email === "true" && (params?.row?.email === "NA" ||
                params?.row?.email === "-") ? (

                <span
                    style={{
                        color: "#007bff",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleEmailUnlock(params.row.apiId);
                    }}
                >
                    {loadingRows[params.row.apiId] ? (
                        <div>
                            <CircularProgress size={16} />
                        </div>
                    ) : (
                        <><div >
                            <Tooltip
                                title="Enrichment uses 1 credit per email record"
                                arrow
                                placement="top"
                            >
                                <span className='unlock-item'>
                                    <span style={{ marginRight: 8 }}>{emailAccessSuccess}</span>
                                    Unlock</span>
                            </Tooltip>
                        </div></>
                    )}
                </span>

            ) : (
                <><div>{(params.value !== "-" && params.value !== "NA") ? <span className='locked_value'><i
                    className="fa fa-envelope"
                    style={{ marginRight: 8 }}
                />{params.value}</span> :
                    <>{params?.row?.enrich_status === 0 ?
                        <>
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEmailUnlock(params.row.apiId, "enrich");
                                }}
                            >
                                <Tooltip
                                    title="No email found for this record"
                                    arrow
                                    placement="top"
                                >
                                    <span className="unlock-item">

                                        <span style={{ marginRight: 8, cursor: "help" }}>
                                            {emailAccessFail}
                                        </span>


                                        Unlock
                                    </span>
                                </Tooltip>
                            </div>
                        </> :
                        <>
                            <div>
                                <span className="unlocked-no-item">

                                    <span style={{ marginRight: 8, cursor: "help" }}>
                                        {emailAccessFail}
                                    </span>
                                    No Email
                                </span>
                            </div>
                        </>}
                    </>
                }</div></>
            );
        }

        return params.value || 'NA';
    };

    // Define DataGrid columns
    const columns = [
        { field: 'id', headerName: 'ID', width: 70, renderCell: renderSkeletonCell },
        { field: 'Name', headerName: 'Name', width: 130, renderCell: renderSkeletonCell },
        // { field: 'lastName', headerName: 'Last Name', width: 130, renderCell: renderSkeletonCell },
        { field: 'jobLevel', headerName: 'Job Level', width: 180, renderCell: renderSkeletonCell },
        { field: 'jobDepartment', headerName: 'Job Department', width: 180, renderCell: renderSkeletonCell },
        { field: 'title', headerName: 'Title', width: 220, renderCell: renderSkeletonCell },
        { field: 'company', headerName: 'Company', width: 200, renderCell: renderSkeletonCell },
        { field: 'website', headerName: 'Website', width: 180, renderCell: renderSkeletonCell },
        {
            field: 'phone',
            headerName: 'Phone',
            width: 160,
            renderCell: renderSkeletonCell,
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 260,
            renderCell: renderSkeletonCell,
        },
        { field: 'industry', headerName: 'Industry', width: 180, renderCell: renderSkeletonCell },
        { field: 'subIndustry', headerName: 'SubIndustry', width: 250, renderCell: renderSkeletonCell },
        { field: 'technology', headerName: 'Technology', width: 150, renderCell: renderSkeletonCell },
        { field: 'city', headerName: 'City', width: 130, renderCell: renderSkeletonCell },
        { field: 'state', headerName: 'State', width: 130, renderCell: renderSkeletonCell },
        { field: 'country', headerName: 'Country', width: 130, renderCell: renderSkeletonCell },
        { field: 'zipCode', headerName: 'Zip Code', width: 130, renderCell: renderSkeletonCell },
        { field: 'sicCode', headerName: 'Sic Code', width: 130, renderCell: renderSkeletonCell },
        { field: 'revenue', headerName: 'Revenue', width: 150, renderCell: renderSkeletonCell },
        { field: 'employee', headerName: 'Employee', width: 150, renderCell: renderSkeletonCell },
    ];

    // Helper to map API response to DataGrid row format
    const transformSearchContactData = (data) => {
        return data.map((item, index) => ({
            // id: (index + 1) + ((page - 1) * rowsPerPage),
            id: (index + 1),
            apiId: item.id,
            source_id: item.source_id,
            Name: `${item.firstname || ""} ${(item.lastname && item.lastname !== "-") ? item.lastname : ""}`.trim(),
            // lastName: item.lastname || 'NA',
            jobLevel: item.job_level || 'NA',
            jobDepartment: item.job_department || 'NA',
            title: item.job_title || 'NA',
            company: item.company || 'NA',
            website: item.website || 'NA',
            phone: item.phone || 'NA',
            email: item.email || 'NA',
            industry: item.industry || 'NA',
            subIndustry: item.sub_industry || 'NA',
            technology: item.technology || 'NA',
            city: item.city || 'NA',
            state: item.state || 'NA',
            country: item.country || 'NA',
            zipCode: item.zipcode || 'NA',
            sicCode: item.sic_code || 'NA',
            revenue: item.revenue || 'NA',
            employee: item.employee_size || 'NA',
            list_name: item.list_name,
            has_email: item.has_email,
            has_phone: item.has_phone,
            enrich_status: item.enrich_status,
            phone_status: item.phone_status,
            email_status: item.email_status,
            provider: item.provider || listProvider || null,
        }));
    };

    let rows = [];

    if (loading) {
        // show skeleton rows
        rows = Array.from({ length: 16 }).map((_, index) => ({
            id: index + 1,
            apiId: null,
            firstName: '',
            lastName: '',
            jobLevel: '',
            jobDepartment: '',
            title: '',
            company: '',
            website: '',
            phone: '',
            email: '',
            industry: '',
            subIndustry: '',
            technology: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            sicCode: '',
            revenue: '',
            employee: '',
            list_name: '',
            isSkeleton: true,
        }));
    } else {
        // only transform if getViewedContacts is an array
        rows = Array.isArray(getViewedContacts)
            ? transformSearchContactData(getViewedContacts)
            : [];
    }

    // Backend already returns paginated data, so no need to slice
    const paginatedRows = rows;

    const scrollContainerRef = React.useRef(null);

    React.useEffect(() => {
        const container = document.querySelector('.MuiDataGrid-virtualScroller');
        if (!container) return;

        let lastScrollTop = 0;

        const handleScroll = () => {
            if (!container || loadingMore) return;
            const currentScrollTop = container.scrollTop;
            if (currentScrollTop <= lastScrollTop) return;
            lastScrollTop = currentScrollTop;

            const distanceFromBottom = container.scrollHeight - currentScrollTop - container.clientHeight;
            if (distanceFromBottom < 5 && getViewedContacts.length < totalDataCount && !loadingMore) {
                const newPage = page + 1
                setPage(newPage);
                setLoadingMore(true);
                fetchViewedContact(newPage, selectFilter);
            }
        };

        container.addEventListener('scroll', handleScroll);

        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingMore, getViewedContacts.length, totalDataCount, setPage]);

    const refetchAfterDelete = () => {
        fetchViewedContact(1, selectFilter)
    }

    const handleDeleteViewedData = async () => {
        if (!selectedRowsData.length) return;

        const result = await Swal.fire({
            title: "Delete Contacts?",
            text: "Are you sure want to delete these contacts for you?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "No",
            reverseButtons: true,
            backdrop: true,
        });
        console.log(result, "result")
        if (!result.isConfirmed) return;

        const contacts = selectedRowsData
            .map((item) => {
                const row = paginatedRows.find((r) => r.id === item.id);
                return row?.apiId ? {
                    contact_id: parseInt(row.apiId),
                    list_name: row.list_name,
                } : null;
            })
            .filter(Boolean);

        if (!contacts.length) return;

        const clearSelection = () => {
            setSelectedRowIds({
                type: 'include',
                ids: new Set(),
            });
            setSelectedRowsData([]);
            setResetKey(prev => prev + 1);
        };

        const requestPayload = {
            user_id: parseInt(signInDetails[0]?.id),
            user_name: signInDetails[0]?.name,
            sbn_id: signInDetails[0]?.sbn_id,
            contacts,
        };

        console.log(requestPayload, "requestPayload")

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };

        // console.log(requestPayload, 'requestPayload');
        dispatch(postDeleteViewedContactsData(requestOption, refetchAfterDelete, clearSelection));
    };

    const CustomNoRowsOverlay = () => (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            p={2}
        >
            <img src={noDataGif} alt="No Data" width={180} style={{ marginBottom: 10 }} />
            <Typography variant="subtitle1" color="textSecondary">
                No Data Available
            </Typography>
        </Box>
    );

    const handleUnlockAllContacts = async () => {

        let source_Id = [];


        if (selectedRowsData.length !== 0) {

            source_Id = selectedRowsData
                .filter(
                    (item) =>
                        item.phone_status !== "true" &&
                        (
                            !item.phone ||
                            item.phone === "-" ||
                            item.phone === null ||
                            item.phone === ""
                        )
                )
                .map((item) => item.source_id);

        }
        // else {

        //     source_Id = getViewedContacts
        //         .filter(
        //             (item) =>
        //                 !item.phone ||
        //                 item.phone === "-" ||
        //                 item.phone === null ||
        //                 item.phone === ""
        //         )
        //         .map((item) => item.source_id);

        // }

        console.log(source_Id, "source_Id")

        if (source_Id.length === 0) {
            toast.warning(`You have selected all unlocked contacts.`);
            return;
        }

        const unlocked_data = selectedRowsData.length - source_Id.length;

        const credit = source_Id.length * 9
        const result = await Swal.fire({
            title: 'Unlock Contacts?',
            html: `
        <div style="text-align: center; line-height: 1.6;">
            <p style="font-size: 16px; color: #555; margin-bottom: 20px;">
                You have selected
                <strong style="color: #2563eb;">${source_Id.length} contacts</strong>
                to unlock. ${unlocked_data !== 0 ? `${unlocked_data} contacts already unlocked.` : ""} 
            </p>

            <div style="
                background: #f8fafc;
                border: 1px solid #e2e8f0;
                border-radius: 12px;
                padding: 16px;
                margin-bottom: 20px;
            ">
                <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                    <span>📞 Phone Credits</span>
                    <strong>9 Credits/Contact</strong>
                </div>

                <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                    <span>✉️ Email Credits</span>
                    <strong>Free</strong>
                </div>

                <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 12px 0;" />

                <div style="display: flex; justify-content: space-between; font-size: 18px;">
                    <strong>Total Credits</strong>
                    <strong style="color: #dc2626;">
                        ${credit} Credits
                    </strong>
                </div>
            </div>

            <p style="font-size: 14px; color: #64748b;">
                Proceeding will deduct these credits from your account.
            </p>
        </div>
    `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Unlock",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#2563eb",
            cancelButtonColor: "#dc2626",
            reverseButtons: true,
            focusCancel: true,
            width: "500px",
            customClass: {
                popup: "rounded-xl",
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn",
            }
        });

        if (!result.isConfirmed) return;

        if (getCredits.credits_aval < credit) {
            toast.warning(`You dont have enough credits to unlock the phone. Please upgrade the plan`);
            return;
        }

        // unique batch id
        setBulkUnlock(true)
        const batch_id = Date.now().toString();

        const payload = {
            batch_id,
            user_id: signInID,
            user_name: signInDetails[0].name,
            sbn_id: sbnID,
            // list_name: "Default",
            list_name: listName,
            provider: (
                listProvider ||
                sessionStorage.getItem("list_provider") ||
                "salestarget"
            ).toLowerCase(),
            contacts: source_Id.map((id) => ({
                id
            }))
        };

        const response = await dispatch(
            unlockBulkPhone(payload)
        );

        if (response?.success) {
            const allEnrichedData = response.all_enriched_data || [];
            startProgressTracking(source_Id, allEnrichedData);
        }
    };

    const startProgressTracking = (source_Id, allEnrichedData) => {
        const interval = setInterval(async () => {
            const completed = await getAllUnlockedPhones(
                source_Id,
                interval,
                allEnrichedData
            );

            if (completed) {
                clearInterval(interval);
            }
        }, 3000);
    };

    let interval_count = 0
    const getAllUnlockedPhones = async (source_Id, interval, allEnrichedData) => {
        const response = await fetch(
            `${aiBaseUrl}ai/get-all-unlocked-phones`
        );
        const data = await response.json();
        interval_count = interval_count + 1
        // if (data.total === source_Id.length || data.total > source_Id.length) {
        if (data.data.length !== 0) {
            clearInterval(interval);
            const post_data = {
                user_id: parseInt(signInDetails[0].id),
                user_name: signInDetails[0].name,
                sbn_id: signInDetails[0].sbn_id,
                list_name: listName
            }

            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(post_data),
            };

            dispatch(insertBulkPhones(requestOption)).then(
                (resp) => {
                    let bulkData = resp.data;

                    console.log(bulkData, "bulkData");

                    if (resp.success) {
                        // updateContactsFromEnrichedData(allEnrichedData);
                        let updatedData = updateContactsFromEnrichedData(allEnrichedData);
                        updatedData = updatedData.map((item) => {
                            const matched = bulkData.find(
                                (x) => x.person_id === item.source_id
                            );

                            if (matched) {
                                return {
                                    ...item,
                                    phone: matched.phone,
                                    email_status: "true",
                                    phone_status: "true",
                                    enrich_status: 1
                                };
                            }
                            return item;
                        });

                        dispatch(getupdateViewedContactsData(updatedData));
                        setSelectedRowIds({
                            type: 'include',
                            ids: new Set(),
                        })
                        setSelectedRowsData([])
                        setBulkUnlock(false)
                        // window.location.reload();
                    } else {
                        updateContactsFromEnrichedData(allEnrichedData);
                        setBulkUnlock(false)
                        alert(`Something went wront while unlocking mobile. Please reload and try.`);
                        window.location.reload();
                    }
                }
            ).catch((err) => {
                updateContactsFromEnrichedData(allEnrichedData);
                console.log(err)
            });
        } else if (interval_count >= 5) {
            updateContactsFromEnrichedData(allEnrichedData);
            clearInterval(interval);
            setBulkUnlock(false)
            toast.error(`Data enriched, But phone unlokced failed. Server not connecting to phone data.`);
        }
    };

    const updateContactsFromEnrichedData = (allEnrichedData) => {

        const updatedData = getViewedContacts.map((item) => {

            const resp = allEnrichedData.find(
                (x) => x.id === item.source_id
            );

            if (!resp) return item;

            const person = resp.full_person || resp;
            const organization = person.organization || {};

            return {
                ...item,
                firstname: person.first_name,
                lastname: person.last_name,
                email: person.email,
                phone: person.phone,
                state: person.state,
                city: person.city,
                country: person.country,
                zipcode: organization.postal_code,
                industry: (organization.industries || []).join(", "),
                sub_industry: (organization.secondary_industries || []).join(", "),
                technology: (organization.technology_names || []).join(", "),
                job_level: person.seniority,
                job_department: (person.departments || []).join(", "),
                address: organization.raw_address,
                website: organization.website_url,
                email_status: "true",
                enrich_status: 1
            };
        });

        dispatch(getupdateViewedContactsData(updatedData));

        setSelectedRowIds({
            type: "include",
            ids: new Set(),
        });

        setSelectedRowsData([]);
        setBulkUnlock(false);

        return updatedData;
    };

    // region select all button
    React.useEffect(() => {
        if (!isSelectAll) return;

        setSelectedRowIds((prev) => {
            const currentIds = rows.map((row) => row.id);

            // Prevent unnecessary updates
            if (
                prev.length === currentIds.length &&
                prev.every((id, index) => id === currentIds[index])
            ) {
                return prev;
            }

            // return currentIds;
            return {
                type: 'include',
                ids: new Set(currentIds),
            };
        });

        setSelectedRowsData((prev) => {
            if (prev.length === rows.length) {
                return prev;
            }

            return rows;
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows.length, isSelectAll]);
    // endregion

    // region filtered data
    // const getFilteredData = (val) => {
    //     setPage(1)
    //     setSelectFilter(val)
    //     alert("page fileter locked data")
    //     fetchViewedContact(1, val)
    // } 

    // updated one to avoid handlescroll function
    const lastScrollTopRef = React.useRef(0);
    const getFilteredData = (val) => {

        console.log("🟢 FILTER CHANGED:", val);

        setPage(1);
        setSelectFilter(val);

        lastScrollTopRef.current = 0;

        const container = document.querySelector(
            '.MuiDataGrid-virtualScroller'
        );

        if (container) {
            container.scrollTop = 0;
        }

        fetchViewedContact(1, val);
    };


    return (
        <>
            <div className='listname-count-div' ref={div2Ref}>
                <div className='listname-filter'>
                    <p className='d-flex'>List Name- <b>{listName}</b> &nbsp;(<span>{loading ? <Skeleton style={{ width: "40px" }} /> : totalDataCount}</span>)</p>
                    <div>
                        <Select
                            flip={true}
                            className="w-100"
                            id="contact-level"
                            options={filterDropdowns}
                            placeholder="Select"
                            value={selectFilter}
                            onChange={(val) => getFilteredData(val)}
                            styles={{
                                container: (provided) => ({
                                    ...provided,
                                    width: "180px",
                                    minWidth: "180px",
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    minHeight: "40px",
                                    height: "35px",
                                }),
                                valueContainer: (provided) => ({
                                    ...provided,
                                    height: "35px",
                                    padding: "0 8px",
                                }),
                                indicatorsContainer: (provided) => ({
                                    ...provided,
                                    height: "35px",
                                }),
                            }}
                        />
                    </div>
                </div>
                <div className='view-contacts-btn'>
                    {/* {(selectFilter.value !== "Enriched" && selectedRowsData.length !== 0) && <SearchBtn btnName="Unlock Contacts" onClickEffect={handleUnlockAllContacts} />} */}
                    {selectFilter.value === "Enriched" && <SearchBtn btnName="Download" onClickEffect={handleDownload} />}
                    {selectedRowsData.length !== 0 && <DeleteBtn btnName="Delete From List" onClickEffect={handleDeleteViewedData} />}
                </div>
            </div>
            <div style={{ position: 'relative' }}>
                <Box sx={{ width: '100%', mt: 2 }}>
                    {/* <Paper sx={{ height: 300, width: '100%' }}> */}
                    <DataGrid
                        columnHeaderHeight={45}
                        rowHeight={45}
                        key={resetKey}
                        sx={{ height: `${tableHeight}px !important` }}
                        ref={scrollContainerRef}
                        // autoHeight
                        pagination={false}
                        rowCount={totalDataCount}
                        paginationMode="server"
                        rows={paginatedRows}
                        columns={columns}
                        hideFooter
                        checkboxSelection
                        className="search-contact-data-grid"
                        getRowId={(row) => row.id}
                        onRowClick={(row) => row.id}
                        getRowClassName={(params) =>
                            params.row?.isSkeleton ? 'skeleton-row' : ''
                        }
                        onRowSelectionModelChange={(newSelection) => {
                            let updatedIds = [];
                            if (newSelection.type === "exclude") {
                                const excludedIds = Array.from(newSelection.ids);
                                updatedIds = paginatedRows
                                    .map(row => row.id)
                                    .filter(id => !excludedIds.includes(id));
                                setIsSelectAll(true);
                            } else {
                                updatedIds = Array.from(newSelection.ids || []);
                                const allLoadedIds = paginatedRows.map(row => row.id);

                                const selectAllClicked =
                                    allLoadedIds.length > 0 &&
                                    allLoadedIds.every(id => updatedIds.includes(id));

                                setIsSelectAll(selectAllClicked);
                            }
                            setSelectedRowIds({
                                type: 'include',
                                ids: new Set(updatedIds),
                            });
                            const selectedData = paginatedRows.filter(row =>
                                updatedIds.includes(row.id)
                            );
                            setSelectedRowsData(selectedData);
                        }}
                        rowSelectionModel={selectedRowIds}
                        loading={loading}
                        components={{
                            NoRowsOverlay: CustomNoRowsOverlay,
                        }}
                    />
                    {loadingMore && <div className='loader-css'>
                        <div className="d-flex justify-content-center align-items-center py-4">
                            <Circles
                                height="30"
                                width="30"
                                color="#007bff"
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                        </div>
                    </div>}

                    {/* </Paper> */}
                </Box>
            </div>
        </>
    );
}

